import AssignmentIcon from '@mui/icons-material/Assignment';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import CampaignIcon from '@mui/icons-material/Campaign';
import SecurityIcon from '@mui/icons-material/Security';
import PersonIcon from '@mui/icons-material/Person';
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';

export const Types = [
  { label: 'M/Y', id: 'M/Y' },
  { label: 'S/Y', id: 'S/Y' },
];

export const RegistryTypes = [
  { label: 'COMMERCIAL', id: 'COMMERCIAL' },
  { label: 'PRIVATE', id: 'PRIVATE' },
  { label: 'YET', id: 'YET' },
  { label: 'DUAL REGISTRATION', id: 'DUAL REGISTRATION' },
];

export const InvoicingEntity = [
  { id: 'COMPANY', label: 'COMPANY' },
  { id: 'NATURAL PERSON', label: 'NATURAL PERSON' },
];

export const PortOfRegistry = [
  { id: 'MARINA DI OLBIA', label: 'MARINA DI OLBIA' },
  { id: 'MOLO BRIN / ISOLA BIANCA', label: 'MOLO BRIN / ISOLA BIANCA' },
  { id: 'CAGLIARI', label: 'CAGLIARI' },
];

export const FeesType = [
  { id: 'DIRECTLY', label: 'DIRECTLY', value: "I'll pay the ports directly." },
  {
    id: 'NOT DIRECTLY',
    label: 'NOT DIRECTLY',
    value: 'Nautica Assistance will take care of the berth payments.',
  },
];

export const RegistrationStatus = [
  { id: 'DRAFT', label: 'DRAFT', color: 'warning', hex: '#ed6c02' },
  { id: 'COMPLETED', label: 'COMPLETED', color: 'success', hex: '#2e7d32' },
  { id: 'DELETED', label: 'DELETED', color: 'error', hex: '#d32f2f' },
  // { id: 'LITE', label: 'LITE', hex: '#abcdef' },
  { id: 'PENDING', label: 'PENDING', hex: '#ffee58' },
  { id: 'ONLINE', label: 'ONLINE', color: 'success', hex: '#2e7d32' },
  { id: 'MANUAL', label: 'MANUAL' },
];

export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};

export const getColorConfig = (value) => {
  if (value === true) {
    return {
      textColor: 'green',
      iconColor: 'success',
    };
  } else if (value === false) {
    return {
      textColor: 'red',
      iconColor: 'red',
    };
  } else {
    return {
      textColor: '#757575',
      iconColor: 'default',
    };
  }
};

export const getIcon = (type, value) => {
  const config = getColorConfig(value);
  switch (type) {
    case 'terms':
      return <AssignmentIcon color={config.iconColor} />;
    case 'marketing':
      return <CampaignIcon color={config.iconColor} />;
    case 'newsletter':
      return value === true
        ? <MarkEmailReadIcon color="success" />
        : <UnsubscribeIcon color={config.iconColor} sx={{ fontSize: '27px', mt: '3px' }} />;
    case 'privacy':
      return <SecurityIcon color={config.iconColor} />;
    case 'profiling':
      return <PersonIcon color={config.iconColor} />;
    default:
      return null;
  }
};

export const STATUS_ONLINE = 'ONLINE';
export const STATUS_DRAFT = 'DRAFT';
